export const dispatch = (name: string, data?: Record<string, string | number>) => {
  console.log(`Firing event '${name}' ${data ? JSON.stringify(data) : ''}`)
  if (window?.gtag) window.gtag('event', name, data)
}
